import Service from '@ember/service';
import { service } from '@ember/service';
import { computed } from '@ember/object';
import Consts from '../utils/constants';

export default class UrlDataService extends Service {
    @service('data') model;
    @service('aditools-site') siteconfig;

    adc = null;

    load() {
        this.set('apiUrl', `${this.siteconfig.ApiUrl}/download/${this.siteconfig.AdiLocale}`);
        this.set('feedbackUrl', `${this.siteconfig.ApiUrl}/feedback/${this.siteconfig.AdiLocale}`);
        this.set('siteUrl', this.siteconfig.SiteUrl);
        this.set('analogHomeUrl', `${this.siteconfig.SiteUrl}/${this.siteconfig.AdiLocale}`);

        this.set('analogBaseParametricSearchUrl', `${this.analogHomeUrl}/parametricsearch`);
        this.set('analogCompanyUrl', `${this.analogHomeUrl}/company.html`);
        this.set('analogProductsUrl', `${this.analogHomeUrl}/products.html`);
        this.set('analogBaseProductsUrl', `${this.analogHomeUrl}/products`);
        this.set('analogApplicationsUrl', `${this.analogHomeUrl}/applications.html`);
        this.set('analogDesignCenterUrl', `${this.analogHomeUrl}/design-center.html`);
        this.set('analogEducationUrl', `${this.analogHomeUrl}/education.html`);
        this.set('analogSupportUrl', `${this.analogHomeUrl}/support.html`);

        this.set('precisionStudioUrl', this.siteconfig.PrecisionStudioUrl);
        this.set('filterWizardUrl', this.siteconfig.FilterWizardUrl);
        this.set('adcDriverUrl', this.siteconfig.CanonicalUrl);
        this.set('photodiodeUrl', this.siteconfig.PhotodiodeUrl);
        this.set('diamondUrl', this.siteconfig.DiamondUrl);
        this.set('simddsUrl', this.siteconfig.SimddsUrl);
        this.set('virtevalUrl', this.siteconfig.VirtEvalUrl);
        this.set('dacErrorCalculatorUrl', this.siteconfig.DACErrorCalculatorUrl);

        this.set('chromeDownloadUrl', `http://www.google.cn/intl/${this.siteconfig.AdiLocale}/chrome/`);
        this.set('firefoxDownloadUrl', `https://www.mozilla.org/${this.siteconfig.AdiLocale}/firefox/new/`);
        this.set(
            'ieDownloadUrl',
            `https://www.microsoft.com/${this.siteconfig.FullLocale}/download/internet-explorer.aspx`,
        );
    }

    getDatasheetUrl(part) {
        let productPage = part.productPage || part.partCore;
        if (!productPage) return null;
        else return `${this.analogHomeUrl}/${productPage}`;
    }

    /**
     * Filter Strings
     */

    @computed('model.selectableDriverOptions') get opAmpFilterString() {
        return this._getFilterString(
            this.model.selectableDriverOptions,
            (driver) => driver.type === Consts.DRIVER_TYPE.AMP,
        );
    }

    @computed('model.selectableDriverOptions') get diffAmpFilterString() {
        return this._getFilterString(
            this.model.selectableDriverOptions,
            (driver) => driver.type === Consts.DRIVER_TYPE.DIFF_AMP,
        );
    }

    @computed('model.selectableAdcOptions') get adcFilterString() {
        return this._getFilterString(this.model.selectableAdcOptions, (adc) => adc);
    }

    _getFilterString(filterArray, inFilter) {
        filterArray = filterArray || [];
        inFilter = inFilter || ((item) => item);
        return (
            filterArray
                // initial filter
                .filter((filterItem) => inFilter(filterItem))
                // get only the item name, removing the hyphen and following characters
                .map((filterItem) =>
                    filterItem.part.slice(
                        0,
                        filterItem.part.indexOf('-') != -1 ? filterItem.part.indexOf('-') : filterItem.part.length,
                    ),
                )
                // remove duplicates
                .removeDuplicates()
                .join('|')
        );
    }

    /**
     * Other useful helper methods
     */

    /**
     * This finds the adc found in the url route (before the hash) and returns it.
     * Since we only want to get it once (the first time),
     * we are going to delete it upon use.
     */
    findAdcParam() {
        let adc = this.adc;
        if (adc) {
            // only return once
            this.set('adc', null);
        }

        return adc;
    }
}
